export const Roles = {
  ADMIN: 'company_admin',
  GLOBAL_MANAGER: 'global_manager',
  GLOBAL_COACH: 'global_coach',
  AUTHOR: 'author',
  LEARNER: 'talent',
} as const;

export type Role = (typeof Roles)[keyof typeof Roles];
